import Analytics from 'analytics-opencare';
import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { updateOngoingCareNoMatch } from 'connect/actions';
import { Form, StepFormWrapper, StepHeader, StepHeaderSubtext, StepHeaderText, StepWrapper } from 'pages/checkout/components/common/layout-styled-components';
import { useNextCheckoutStep } from 'pages/checkout/hooks/checkoutStepHooks';
import { useCheckoutRedesignAnalyticsData } from 'pages/checkout/utils/analyticsUtils';
import SingleSelect from 'pages/common/components/SingleSelect/SingleSelect';
import { OptionBlock } from 'pages/common/styled-components';
import { selectOngoingCareNoMatch } from 'pages/legacy-checkout/connect/selectors';

const analytics = new Analytics();

const careOptions = [
  {
    id: 'Yes',
    title: 'Yes',
    description: 'I am looking for a new dentist for ongoing care',
  },
  {
    id: 'No',
    title: 'No',
    description: 'I just need a one-off appointment for a specific issue',
  },
];

export const OngoingCareQuestion = () => {
  const dispatch = useDispatch();
  const { goToNextStep } = useNextCheckoutStep();
  const analyticsData = useCheckoutRedesignAnalyticsData();

  const savedAnswer = useSelector(selectOngoingCareNoMatch);

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.CHECKOUT,
      pageName: 'checkout-ongoing-care',
      name: 'checkout',
      section: 'ongoing-care',
      ...analyticsData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- analyticsData is a new object every time, so we don't want it in the dependency array
  }, []);

  const onSelection = (value: string, _index: number) => {
    // Track selection
    analytics.trackForm({
      pageType: analytics.pageTypes.CHECKOUT,
      pageName: 'checkout-ongoing-care',
      name: 'checkout',
      section: 'ongoing-care',
      content: {
        ongoing_care: String(value),
        ...analyticsData.content,
      },
    });

    dispatch(updateOngoingCareNoMatch(value));
    goToNextStep();
  };

  return (
    <StepWrapper>
      <StepHeader>
        <StepHeaderText>
          Are you looking to join a new practice for ongoing care?
        </StepHeaderText>
        <StepHeaderSubtext>
          This allows the practice to structure your first appointment correctly.
        </StepHeaderSubtext>
      </StepHeader>

      <StepFormWrapper>
        <Form>
          <OptionBlock>
            {careOptions.map((option, i) => (
              <SingleSelect
                key={option.id}
                id={option.id}
                title={option.title}
                description={option.description}
                describedBy="title"
                onChange={(e) => onSelection(e, i)}
                selected={option.id === savedAnswer}
              />
            ))}
          </OptionBlock>
        </Form>
      </StepFormWrapper>
    </StepWrapper>
  );
};
